import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { width = 24, height = 24, color = '#363531' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={color}
        d="M8.625 6.75a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25zM15.375 6.75a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25zM8.625 13.125a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25zM15.375 13.125a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25zM8.625 19.5a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25zM15.375 19.5a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25z"
      />
    </svg>
  );
}

export default Icon;
